var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 0.642578H1.92854C1.58754 0.642578 1.26052 0.778037 1.0194 1.01916C0.778281 1.26027 0.642822 1.5873 0.642822 1.92829V16.0711C0.642822 16.4121 0.778281 16.7392 1.0194 16.9803C1.26052 17.2214 1.58754 17.3569 1.92854 17.3569H13.5C13.841 17.3569 14.168 17.2214 14.4091 16.9803C14.6502 16.7392 14.7857 16.4121 14.7857 16.0711V10.2854M0.642822 13.4997H14.7857M4.49997 3.85686H7.07139M4.49997 7.07115H5.78568",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5637 9.65003L7.70654 10.3443L8.3494 6.43575L13.788 1.02289C13.9075 0.902382 14.0497 0.806732 14.2064 0.741458C14.363 0.676184 14.5311 0.642578 14.7008 0.642578C14.8706 0.642578 15.0386 0.676184 15.1953 0.741458C15.352 0.806732 15.4942 0.902382 15.6137 1.02289L16.9765 2.38575C17.0971 2.50527 17.1927 2.64747 17.258 2.80415C17.3232 2.96082 17.3569 3.12887 17.3569 3.2986C17.3569 3.46833 17.3232 3.63638 17.258 3.79306C17.1927 3.94974 17.0971 4.09194 16.9765 4.21146L11.5637 9.65003Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackMobile);
export default __webpack_public_path__ + "static/media/feedbackMobile.a174f4ff7f72c999f362958bf29c4a5e.svg";
export { ForwardRef as ReactComponent };